import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { nullSafe } from 'Utility/globalMethods';
import { portalModalSelector } from 'Store/selectors';
import { goPopup } from 'Store/actions/portalModalActions';
import * as actionLayer from '../../modules/CustomerCareActions';
import EnableCustomerCarePopup from './EnableCustomerCarePopup';

const mapDispatchToProps = (dispatch) => ({
	enableCustomerCare: (item) => dispatch(actionLayer.enableCustomerCareUser.request(item)),
	goPopup: (popup) => dispatch(goPopup(popup)),
	closeModal: () => dispatch(goPopup('')),
	...bindActionCreators(actionLayer, dispatch),
});

const mapStateToProps = (state) => ({
	isLoading: nullSafe(() => state.CustomerCare.isLoading, false),
	payload: nullSafe(() => portalModalSelector(state).data.payload, {}),
});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => ({
	...stateProps,
	actions: dispatchProps,
}))(EnableCustomerCarePopup);
